function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { WFS_ID_KEY, WFS_FTR_ID_KEY } from 'oskari-frontend/bundles/mapping/mapmodule/domain/constants';
var removeProps = new Set(['layer', 'geometry', 'bbox']);
var removePropsWithId = new Set([WFS_ID_KEY, WFS_FTR_ID_KEY].concat(_toConsumableArray(removeProps)));
function destructComplex(value) {
  if (typeof value === 'undefined') {
    return '';
  }
  return "".concat(value);
}
function removeComplexPrefix(field) {
  return field.startsWith('$') ? field.substring(1) : field;
}
export function processFeatureProperties() {
  var properties = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var removeId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var remove = removeId ? removePropsWithId : removeProps;
  return Object.fromEntries(Object.entries(properties).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 1),
      key = _ref2[0];
    return !remove.has(removeComplexPrefix(key));
  }).map(function (entry) {
    return _processValue(entry);
  }));
}
function _processValue(_ref3) {
  var _ref4 = _slicedToArray(_ref3, 2),
    key = _ref4[0],
    value = _ref4[1];
  if (key === WFS_ID_KEY) {
    return [WFS_FTR_ID_KEY, value];
  }
  if (key.startsWith('$')) {
    return [removeComplexPrefix(key), destructComplex(value)]; // TODO remove '$' from key??
  }
  return [key, value];
}